import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store/index'
import { isHotelCooperator } from '@/utils/hotelMerchant'
import { isAdminOnlyRoute, isAdminUser, isCustomerService, isCustomerServiceRestrictedRoute } from '@/utils/adminMenu'

const Mlogin = () => import("../views/mlogin.vue");
const Coffee = () => import("../views/coffee.vue");
const MAccount = () => import("../views/account.vue");
const ReportAdmin = () => import("../views/report.vue");
const Message = () => import('../views/message.vue')
const Complaint = () => import("../views/complaint.vue");
const MemberCto = () => import("../views/memberCto.vue");
const QuestionnaireStats = () => import("../views/questionnaireStats.vue");
const SuggestionStats = () => import("../views/suggestionStats.vue");
const CacheClear = () => import("../views/cacheClear.vue");
const OrderQuery = () => import("../views/orderQuery.vue");
const FinanceManage = () => import("../views/financeManage.vue");

const Play = () => import('../components/Message/play.vue')//添加演出
// const Play = () => import('../components/Message/sellDetail.vue')//添加演出
const Screens = () => import('../components/Message/screens.vue')//出票
// const Screens = () => import('../components/Message/sellDetailNew.vue')//出票
const Plan = () => import('../components/Message/plan.vue')//影厅
const Staff = () => import('../components/Message/staff.vue')//账户 = account
const Order = () => import("../components/Message/order.vue");//出票
const zyOrder = () => import("../components/Message/zyOrder.vue");//出票
const Refund = () => import("../components/Message/refund.vue");//退票
const RefundMana = () => import("../components/Message/refundMana.vue");//退票
const Customer = () => import("../components/Message/customer.vue")//顾客
const Count = () => import('../components/Message/count.vue')//分析
const Report = () => import("../components/Message/report.vue");//报表
const Detalied = () => import('../components/Message/detalied.vue')//
const SellDetail = () => import("../components/Message/sellDetail.vue");//影院售出详情
const Ticket = () => import("../components/Message/ticket.vue");//记忆打印
const zyTicket = () => import("../components/Message/zyTicket.vue");//记忆打印
const Goods = () => import("../components/Message/goods.vue");//景区
const YlGoods = () => import("../components/Message/ylGoods.vue");//瑶里打印票
const Sell = () => import("../components/Message/sellDetailNew.vue");//出票
const SellO = () => import("../components/Message/sell.vue");//出票
const Convert = () => import("../components/Message/convert.vue");//
const Account = () => import("../components/Message/account.vue");//账户 = staff
const Finance = () => import("../components/Message/finance.vue");//财务
const FinanceDetail = () => import("../components/Message/financeDetail.vue");//财务
const Channel = () => import("../components/Message/channel.vue");//渠道
const ReportJY = () => import("../components/Message/report_jiyi.vue");//渠道
const FenXiao = () => import("../components/Message/fenxiao.vue");//渠道
const SellSim = () => import("../components/Message/sellDetailSim.vue");//渠道售票
const HotelRoomType = () => import("../views/hotelRoomType.vue");//酒店房型（商家）
const HotelRealtimeOrder = () => import("../views/hotelRealtimeOrder.vue");//酒店实时订单（商家）

Vue.use(VueRouter)

const routes = [
  {
    path: "",
    component: Mlogin,
    meta: {
      title: "vendorpc",
    },
    children: [],
  },
  {
    path: "/mlogin",
    component: Mlogin,
    meta: {
      title: "管理员登录",
    },
  },
  {
    path: "/report",
    component: ReportAdmin,
    meta: {
      title: "票务统计",
    },
  },
  {
    path: "/coffee",
    component: Coffee,
    meta: {
      title: "咖啡统计",
    },
  },
  {
    path: "/hotelRoomType",
    component: HotelRoomType,
    meta: { title: "房型管理", hotelMerchantOnly: true },
  },
  {
    path: "/hotelRealtimeOrder",
    component: HotelRealtimeOrder,
    meta: { title: "实时订单", hotelMerchantOnly: true },
  },
  {
    path: "/account",
    component: MAccount,
    meta: {
      title: "票务统计",
    },
  },
  {
    path: "/memberCto",
    component: MemberCto,
    meta: {
      title: "会员解封",
    },
  },
  {
    path: "/questionnaireStats",
    component: QuestionnaireStats,
    meta: {
      title: "问卷统计",
    },
  },
  {
    path: "/suggestionStats",
    component: SuggestionStats,
    meta: {
      title: "建议问卷统计",
    },
  },
  {
    path: "/cacheClear",
    component: CacheClear,
    meta: {
      title: "缓存清理",
      adminOnly: true,
    },
  },
  {
    path: "/orderQuery",
    component: OrderQuery,
    meta: {
      title: "订单查询",
      adminOnly: true,
    },
  },
  {
    path: "/financeManage",
    component: FinanceManage,
    meta: {
      title: "财务管理",
      adminOnly: true,
    },
  },
  {
    path: "/complaint",
    component: Complaint,
    meta: {
      title: "客户投诉",
    },
  },
  {
    path: "/message",
    component: Message,
    meta: {
      title: "管理员界面",
    },
    children: [
      {
        path: "/",
        redirect: "/message/count",
      },
      {
        path: "play",
        component: Play,
      },
      {
        path: "order",
        component: Order,
      },
      {
        path: "zyOrder",
        component: zyOrder,
      },
      {
        path: "screens",
        component: Screens,
      },
      {
        path: "plan",
        component: Plan,
      },
      {
        path: "staff",
        component: Staff,
      },
      {
        path: "customer",
        component: Customer,
      },
      {
        path: "count",
        component: Count,
      },
      {
        path: "report",
        component: Report,
      },
      {
        path: "detalied",
        component: Detalied,
      },
      {
        path: "sellDetail",
        component: SellDetail,
      },
      {
        path: "ticket",
        component: Ticket,
      },
      {
        path: "zyticket",
        component: zyTicket,
      },
      {
        path: "goods",
        component: Goods,
      },
      {
        path: "ylGoods",
        component: YlGoods,
      },
      {
        path: "sell",
        component: Sell,
      },
      {
        path: "sellSim",
        component: SellSim,
      },
      {
        path: "convert",
        component: Convert,
      },
      {
        path: "account",
        component: Account,
      },
      {
        path: "refund",
        component: Refund,
      },
      {
        path: "refundMana",
        component: RefundMana,
      },
      {
        path: "finance",
        component: Finance,
      },
      {
        path: "financeDetail",
        component: FinanceDetail,
      },
      {
        path: "channel",
        component: Channel,
      },
      {
        path: "reportjy",
        component: ReportJY,
      },
      {
        path: "fenxiao",
        component: FenXiao,
      },
      {
        path:'sellO',
        component:SellO
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: 'hash',
})

// router.beforeEach((to, from, next) => {
//   // beforeEach是router的钩子函数，在进入路由前执行
//    if (to.meta.title) { //判断是否有标题
//     console.log(to.meta.title)
//     document.title = to.meta.title } else { document.title = '默认title' } next() })

router.beforeEach((to, from, next) => {

    // document.title =  to.matched[0].meta.title
    document.title = '景德镇智慧旅游平台'
    // const favicon = to.meta.favicon || defaultFavicon;
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    console.log(link)
    link.rel = 'shortcut icon';
    link.type = 'image/png';
    link.href = 'public/favicon.png';
    head.appendChild(link);
    console.log(head)

  // const test = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
  // link.setAttribute('href','public/favicon.png');

  // 酒店房型页 /hotelRoomType：类型 2 且 身份类型 4
  if (to.matched.some((r) => r.meta && r.meta.hotelMerchantOnly)) {
    if (!isHotelCooperator()) {
      return next({ path: "/message/count", replace: true })
    }
  }

  if (isCustomerService() && isCustomerServiceRestrictedRoute(to.path)) {
    return next({ path: '/memberCto', replace: true })
  }

  if (isAdminOnlyRoute(to.path) && !isAdminUser()) {
    return next({ path: '/report', replace: true })
  }

  next();


  // console.log(to.path.split('/')[1]);
  //未登录强制跳转到登录页
  // if (to.path === '/mlogin' || to.path === '/complaint')
  //   return next()
  // const tokenStr = window.localStorage.getItem('token')
  // if (!store.state.UserToken) {
  //   // 未登录  判断页面是否要登录meta
  //   return next('/mlogin')
  // } else {
  //   //用户已经登录处理权限
  //   if (to.path === '/message/staff') {
  //     if (store.state.UserToken != "0") {
  //       alert("权限不够")
  //       return next(from.path)
  //     }
  //   }
  // }
})

export default router
